module.exports = __webpack_public_path__ + "assets/img/provider-poster-03.83920444.png";